import { QueryClient } from '@tanstack/react-query';

import { client } from '../client';

import type { QueryFunction, QueryKey, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export type QueryOptionsType<T> = Omit<UseQueryOptions<T, AxiosError, T, QueryKey>, 'queryKey' | 'queryFn'>;

export type MutationOptionsType<TData, TVariables> = Omit<
  UseMutationOptions<TData, AxiosError, TVariables>,
  'mutationFn'
>;

const defaultQueryFn: QueryFunction<unknown, QueryKey> = async ({ queryKey }) => {
  const endpoint = queryKey[0] as string;
  const { data } = await client.get(endpoint, {
    // withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  return data;
};

export const queryClient = new QueryClient({
  defaultOptions: { queries: { queryFn: defaultQueryFn, refetchOnWindowFocus: false, staleTime: 1000 * 60 * 5 } },
});
